module.exports = __webpack_public_path__ + "static/media/Sierra Leone.c16bd8e0.png";